import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SearchState {
  input: string
  query: string | undefined
}

const initialSearchState: SearchState = {
  input: '',
  query: undefined,
}

export const searchSlice = createSlice({
  initialState: initialSearchState,
  name: 'search',
  reducers: {
    updateSearchInputAction(
      state: SearchState,
      { payload }: PayloadAction<string>,
    ) {
      state.input = payload
    },
    updateSearchQueryAction(
      state: SearchState,
      { payload }: PayloadAction<string | undefined>,
    ) {
      state.query = payload
    },
  },
})

export default searchSlice.reducer
